import { useMutation } from "@apollo/client/react";
import { CREATE_RISK_SCORE_ADJUSTMENT } from "../../mutations/aml/createRiskScoreAdjustment";
import GET_CLIENT_RISK_SCORE from "../../queries/aml/getClientRiskScore";

export const useCreateRiskScoreAdjustment = ({ onCompleted, onError }: any) => {
  const [createRiskScoreAdjustment, { data, loading, error }] = useMutation(
    CREATE_RISK_SCORE_ADJUSTMENT,
    {
      refetchQueries: [GET_CLIENT_RISK_SCORE],
      onCompleted: onCompleted,
      onError: onError,
      awaitRefetchQueries: true,
    }
  );

  return { createRiskScoreAdjustment, data, loading, error };
};
